// @flow

import React from "react";
import { AbsenceMonitoringTasksForm } from "@modules/service/components";
import type { AbsenceMonitoring } from "@modules/service/reducer/absence-monitoring/types";

type OwnProps = $Exact<{
  data: AbsenceMonitoring,
  schema: Object,
}>;

type Props = $Exact<{
  ...OwnProps,
}>;

export class AbsenceMonitoringTasksView extends React.Component<Props> {
  get data() {
    return this.props.data.tasks;
  }

  get schema() {
    return (((this.props.schema || {}).properties || {}).tasks || {}).items;
  }

  render() {
    return (
      <div className="mb-4">
        <AbsenceMonitoringTasksForm data={this.data} schema={this.schema} disabled />
      </div>
    );
  }
}

export default AbsenceMonitoringTasksView;
